import Vue from "vue";
import ExpedicaoDetalhes from "../ExpedicaoDetalhes";

Vue.component("expedicao-detalhes", ExpedicaoDetalhes);
